const HolidayPresent = ({
  className,
  height,
  width,
}: {
  className?: string
  height?: string
  width?: string
}) => (
  <svg
    className={className}
    fill="transparent"
    height={height || '101px'}
    viewBox="0 0 79 101"
    width={width || '79px'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_1_25"
        x1="19.2581"
        x2="73.5115"
        y1="85.0059"
        y2="50.2819"
      >
        <stop offset="0.03" stopColor="#FFCC00" />
        <stop offset="0.36" stopColor="#FF9E26" />
        <stop offset="1" stopColor="#FF6141" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_1_25"
        x1="33.3668"
        x2="57.1677"
        y1="74.6258"
        y2="61.386"
      >
        <stop stopColor="#772D67" />
        <stop offset="1" stopColor="#89D8FD" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint2_linear_1_25"
        x1="4.25387"
        x2="75.4303"
        y1="48.7344"
        y2="25.8022"
      >
        <stop offset="0.03" stopColor="#FFCC00" />
        <stop offset="0.36" stopColor="#FF9E26" />
        <stop offset="1" stopColor="#FF6141" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint3_linear_1_25"
        x1="14.3895"
        x2="69.7831"
        y1="41.9923"
        y2="5.99229"
      >
        <stop stopColor="#772D67" />
        <stop offset="1" stopColor="#89D8FD" />
      </linearGradient>
    </defs>
    <path
      d="M71.8192 98.3362V98.9697H12.5431C9.73771 98.9697 7.47527 98.0647 7.47527 96.9787V45.4855C7.47527 44.3995 9.73771 43.4946 12.5431 43.4946H71.8192V98.3362Z"
      fill="url(#paint0_linear_1_25)"
    />
    <path
      d="M46.7514 97.9742V99.0602H32.0002V43.4946H46.7514V97.9742Z"
      fill="url(#paint1_linear_1_25)"
    />
    <path
      clipRule="evenodd"
      d="M8.56153 44.6258C8.10032 44.6258 7.7018 45.0243 7.7018 45.4855V96.9787C7.7018 97.4399 8.10032 97.8384 8.56153 97.8384H70.1C70.5612 97.8384 70.9597 97.4399 70.9597 96.9787V45.4855C70.9597 45.0243 70.5612 44.6258 70.1 44.6258H8.56153ZM5.43936 45.4855C5.43936 43.7748 6.8508 42.3633 8.56153 42.3633H70.1C71.8107 42.3633 73.2222 43.7748 73.2222 45.4855V96.9787C73.2222 98.6894 71.8107 100.101 70.1 100.101H8.56153C6.85081 100.101 5.43936 98.6894 5.43936 96.9787V45.4855Z"
      fill="#6E3264"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M32.0004 42.9063C32.6251 42.9063 33.1316 43.4128 33.1316 44.0375V98.3362C33.1316 98.9609 32.6251 99.4674 32.0004 99.4674C31.3756 99.4674 30.8691 98.9609 30.8691 98.3362V44.0375C30.8691 43.4128 31.3756 42.9063 32.0004 42.9063Z"
      fill="#6E3264"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M46.7515 42.5443C47.3762 42.5443 47.8827 43.0508 47.8827 43.6756V97.9742C47.8827 98.599 47.3762 99.1054 46.7515 99.1054C46.1267 99.1054 45.6203 98.599 45.6203 97.9742V43.6756C45.6203 43.0508 46.1267 42.5443 46.7515 42.5443Z"
      fill="#6E3264"
      fillRule="evenodd"
    />
    <path
      d="M76.5706 31.0964H2.09097V43.7661H76.5706V31.0964Z"
      fill="url(#paint2_linear_1_25)"
    />
    <path
      d="M71.6836 22.6801C69.4212 17.0692 63.0863 14.4448 57.4755 16.7072C54.127 18.0647 48.0637 24.671 43.7198 29.8294H43.5388C46.7062 23.947 50.5071 16.0737 50.5071 12.5443C50.5071 6.57147 45.7107 1.5941 39.6474 1.5941C33.584 1.5036 28.6972 6.39048 28.6972 12.4538C28.6972 15.9832 32.3171 23.947 35.394 29.9199H35.213C30.9596 24.671 24.9868 17.9742 21.6383 16.5262C16.118 14.1733 9.69265 16.7977 7.33971 22.3181C6.16324 25.1235 6.25373 28.2004 7.33971 30.8249L32.2266 31.0059V31.5488L32.1361 44.2185V44.852L46.7967 44.9425V43.8565L46.8872 31.2774V31.0964L71.5931 31.2774C72.6791 28.5624 72.7696 25.4855 71.6836 22.6801Z"
      fill="url(#paint3_linear_1_25)"
    />
    <path
      clipRule="evenodd"
      d="M3.71975 31.5941C3.25853 31.5941 2.86002 31.9926 2.86002 32.4538V32.4643L2.76953 42.2317C2.77189 42.6912 3.1694 43.0873 3.62925 43.0873H3.63646L46.7132 43.3588L74.9415 43.5398C74.9424 43.5398 74.9434 43.5398 74.9443 43.5398C75.4043 43.5382 75.8012 43.1403 75.8012 42.6801V42.6696L75.8917 32.9063C75.8917 32.9049 75.8917 32.9035 75.8917 32.9021C75.8893 32.4427 75.4918 32.0466 75.032 32.0466H71.5026L71.4942 32.0466L46.8872 31.8656H42.7088L36.1102 31.7751H32.1278L7.24916 31.5941H3.71975ZM0.597583 32.448C0.600779 30.7399 2.01096 29.3317 3.71975 29.3317H7.25739L32.136 29.5127H36.1334L42.732 29.6032H46.8955L71.5026 29.7842H75.032C76.7427 29.7842 78.1541 31.1956 78.1541 32.9063V32.9168L78.0636 42.6801C78.0636 42.6821 78.0636 42.6841 78.0636 42.6862C78.0603 44.3942 76.6502 45.8023 74.9415 45.8023L74.9342 45.8022L3.62925 45.3498C3.62793 45.3498 3.62662 45.3498 3.6253 45.3498C1.91635 45.3476 0.50708 43.937 0.50708 42.2276V42.2171L0.597583 32.448Z"
      fill="#6E3264"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M32.0536 29.9652C32.6783 29.9696 33.1812 30.4797 33.1767 31.1044L33.0862 43.7741C33.0817 44.3989 32.5717 44.9017 31.9469 44.8972C31.3222 44.8928 30.8193 44.3827 30.8238 43.758L30.9143 31.0883C30.9188 30.4635 31.4288 29.9607 32.0536 29.9652Z"
      fill="#6E3264"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M46.8048 29.7842C47.4295 29.7887 47.9323 30.2988 47.9278 30.9235L47.8374 43.5027C47.8329 44.1274 47.3228 44.6302 46.698 44.6257C46.0733 44.6212 45.5705 44.1112 45.575 43.4864L45.6655 30.9072C45.67 30.2825 46.1801 29.7797 46.8048 29.7842Z"
      fill="#6E3264"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M43.5016 29.1796C44.0604 29.459 44.2869 30.1385 44.0075 30.6973C43.9304 30.8514 43.8523 30.9684 43.8064 31.0373C43.8046 31.04 43.8029 31.0426 43.8012 31.0451C43.7558 31.1132 43.7464 31.1289 43.736 31.1498C43.4566 31.7086 42.7771 31.9351 42.2183 31.6557C41.6595 31.3763 41.433 30.6968 41.7124 30.138C41.7895 29.9838 41.8676 29.8668 41.9135 29.7979C41.9153 29.7952 41.917 29.7927 41.9187 29.7901C41.9641 29.7221 41.9735 29.7064 41.9839 29.6855C42.2633 29.1267 42.9428 28.9002 43.5016 29.1796Z"
      fill="#6E3264"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M39.4581 2.36334C34.0953 2.36785 29.6475 6.67435 29.6475 12.0918C29.6475 12.8302 29.8526 13.9088 30.2581 15.2719C30.6575 16.6147 31.2276 18.1569 31.9035 19.7935C33.2389 23.0272 34.9619 26.5686 36.5219 29.5607C36.5999 29.663 36.6568 29.7591 36.693 29.8224C36.7541 29.9294 36.8116 30.0443 36.853 30.1273L36.8584 30.138C37.1378 30.6968 36.9113 31.3763 36.3525 31.6557C35.7937 31.9351 35.1142 31.7086 34.8348 31.1498C34.8116 31.1033 34.7922 31.0647 34.7735 31.0284C34.7549 30.9924 34.7404 30.9654 34.7287 30.9449C34.7286 30.9448 34.7285 30.9446 34.7284 30.9445L34.6527 30.8688L34.5724 30.7152C32.9797 27.6662 31.1985 24.0138 29.8123 20.6571C29.1194 18.9793 28.5187 17.3597 28.0895 15.9169C27.6664 14.4943 27.385 13.1635 27.385 12.0918C27.385 5.38548 32.8873 0.100891 39.4665 0.100891H39.4834L39.4834 0.101017C46.1672 0.200776 51.4574 5.59372 51.4574 12.2728C51.4574 13.3761 51.155 14.7245 50.7052 16.1521C50.2489 17.6001 49.6127 19.2155 48.8856 20.8814C47.4312 24.214 45.5822 27.8193 43.9953 30.8119C43.7026 31.3638 43.0179 31.574 42.4659 31.2813C41.914 30.9886 41.7038 30.3039 41.9965 29.7519C43.577 26.7716 45.3932 23.2277 46.8121 19.9765C47.5216 18.3506 48.1241 16.8155 48.5473 15.4722C48.9771 14.1085 49.195 13.0248 49.195 12.2728C49.195 6.82808 44.8969 2.44898 39.4581 2.36334Z"
      fill="#6E3264"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M72.6394 21.9783C70.1362 15.7817 63.1384 12.8961 56.962 15.3866L56.9619 15.3865L56.946 15.3932C55.9318 15.8202 54.7778 16.6233 53.5915 17.5978C52.3882 18.5862 51.0836 19.8081 49.7621 21.1353C47.1184 23.7905 44.3586 26.916 42.1317 29.5519L42.0445 29.6551L42.0209 29.7023C42.019 29.7042 42.0171 29.7062 42.015 29.7082C42.0117 29.7115 42.0079 29.7153 42.0034 29.7197C41.939 29.7832 41.753 29.9667 41.6221 30.2285C41.3427 30.7873 41.5692 31.4668 42.128 31.7462C42.6584 32.0114 43.2975 31.8208 43.6 31.3229C43.6043 31.3185 43.6092 31.3136 43.6148 31.308C43.618 31.3048 43.6219 31.301 43.6263 31.2966C43.6774 31.2462 43.805 31.1204 43.9209 30.9399C46.1173 28.3426 48.8066 25.3015 51.3654 22.7316C52.657 21.4344 53.9034 20.2694 55.0275 19.3461C56.1645 18.4122 57.1118 17.7799 57.8163 17.4815C62.8571 15.454 68.5209 17.8143 70.544 22.8316L70.5439 22.8317L70.5499 22.8461C71.6032 25.3576 71.5212 28.1086 70.4704 30.4526C70.2148 31.0227 70.4698 31.6921 71.0399 31.9476C71.61 32.2032 72.2793 31.9482 72.5349 31.3781C73.8361 28.4755 73.9359 25.0757 72.6394 21.9783Z"
      fill="#6E3264"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M8.2914 22.3061C7.23926 24.8175 7.31803 27.5795 8.29474 29.9399C8.53361 30.5171 8.25928 31.1788 7.68199 31.4177C7.10471 31.6565 6.44308 31.3822 6.2042 30.8049C5.00935 27.9174 4.9068 24.5268 6.20626 21.4281L6.20881 21.422L6.20883 21.4221C8.80366 15.3342 15.8884 12.4332 21.9894 15.0321C23.0097 15.4622 24.1549 16.2756 25.3231 17.2607C26.5095 18.261 27.7895 19.4989 29.0829 20.8439C31.6707 23.5347 34.3627 26.7067 36.5433 29.387L36.6219 29.4836L36.6694 29.5786C36.6743 29.5854 36.6865 29.6013 36.7094 29.6275C36.7593 29.6845 36.822 29.7478 36.9181 29.844C37.3599 30.2858 37.3599 31.002 36.9181 31.4438C36.4764 31.8855 35.7601 31.8855 35.3184 31.4438C35.3085 31.434 35.2977 31.4232 35.2858 31.4115C35.1541 31.2809 34.9068 31.0357 34.7284 30.7413C32.5762 28.0984 29.9544 25.014 27.4522 22.4122C26.1891 21.0988 24.9691 19.9215 23.8647 18.9903C22.7431 18.0446 21.8077 17.4105 21.1091 17.1163L21.1046 17.1144C16.1664 15.0096 10.4032 17.3561 8.2914 22.3061Z"
      fill="#6E3264"
      fillRule="evenodd"
    />
  </svg>
)

export default HolidayPresent
